import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { DlcEpisodeTypeList, EndingType } from 'utils/constant';
import DefaultButton from 'components/button/DefaultButton';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import DefaultLayout from 'components/layout/DefaultLayout';
import DLCEpisodeLocalizingForm from './DLCEpisodeLocalizingForm';
import TextFlexBox from 'components/container/TextFlexBox';
import CheckboxOneType from 'components/input/CheckboxOneType';
import { useDlcEpisodeUpdate, useDlcEpsiodeDetail } from 'apis/story/dlcApis';
import DefaultSelect from 'components/select/DefaultSelect';
import DefaultRadio from 'components/input/DefaultRadio';
import useEpisodeDropQuery from 'hooks/queries/common/useEpisodeDropQuery';
import ImageSelect from 'components/select/ImageSelect';
import { useConnectedCharacter } from 'hooks/queries/story/abilityQuery';
import { usePopThumbnailImgDropList } from 'hooks/dropDownList/storyUpdateDropList';
/**
 * * 작품 관리 - DLC 에피소드 수정
 */

const DLCEpisodeUpdatePage = () => {
  const location = useLocation() as any;
  console.log(location);
  const { setEpisodeClick, setDlcMainStatus } = location?.state;
  const { episode_type, selection_check } = location?.state?.record;
  const navigate = useNavigate();
  const { projectId, dlcId, episodeId } = useParams();

  const [langList, setLangList] = useState<any>(); // 다국어 데이터
  const [detailData, setDetailData] = useState<any>();

  const { data: episodeDropData } = useEpisodeDropQuery(projectId!); // 귀속 에피소드 드롭 리스트
  const { data: characterDropList } = useConnectedCharacter(projectId!); // 캐릭터 드롭다운
  const { data: popThumbnailDropList } = usePopThumbnailImgDropList(projectId!); // 팝업 썸네일 드롭 리스트

  const { data } = useDlcEpsiodeDetail(
    projectId,
    dlcId,
    episodeId,
    location?.state?.lang,
    setDetailData,
    langList,
    setLangList,
  );
  const { mutate: DlcEpisodeUpdate } = useDlcEpisodeUpdate();

  /// 다국어 인풋 이벤트
  const handleLocalInputChange = (e: any) => {
    const { name, id, value } = e.target;
    setLangList(
      langList?.map((v) => (v.lang === id ? { ...v, [name]: value } : v)),
    );
  };

  /// 인풋 이벤트
  const handleInputChange = (e: any) => {
    const { value, name } = e.target;
    setDetailData({ ...detailData, [name]: value });
  };

  /// 드롭다운 이벤트
  const handleSelectChange = (e: string, data: any) => {
    const { name } = data;
    setDetailData({ ...detailData, [name]: e });
  };

  /// 서버 전송
  const handleSubmit = () => {
    DlcEpisodeUpdate({ projectId, dlcId, detailData, langList });
  };
  /// 목록 보기
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton
            onClick={handleGoBack}
            backColor={`${theme.colors.sub}`}
          >
            목록보기
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>저장하기</DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox>
        <InputWrappingBox left>
          <DLCEpisodeLocalizingForm
            langList={langList}
            onChange={handleLocalInputChange}
          />
        </InputWrappingBox>
        <div style={{ width: '100%' }}>
          <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
            <InputFlexBox
              style={{
                justifyContent: 'flex-start',
                marginBottom: '1.5rem',
              }}
            >
              <TextFlexBox style={{ marginRight: '2rem' }}>
                <h6>에피소드 ID</h6>
                <p>{location?.state?.record.episode_id}</p>
              </TextFlexBox>
              <TextFlexBox style={{ marginRight: '2rem' }}>
                <h6>스토리 종류</h6>
                <>
                  {DlcEpisodeTypeList?.map(
                    (v) => v.value === episode_type && <p>{v.text}</p>,
                  )}
                </>
              </TextFlexBox>
              <TextFlexBox style={{ marginRight: '1rem' }}>
                <h6>선택지 확정</h6>
                {/* 선택지 확정 여부(0: 확정 X, 1: 확정 O)  */}
                <CheckboxOneType
                  checked={selection_check === 1 ? true : false}
                  disabled={true}
                />
              </TextFlexBox>
            </InputFlexBox>
            <>
              {episode_type === 'ending' && (
                <InputFlexBox>
                  <DefaultSelect
                    title='귀속 에피소드'
                    name='depend_episode'
                    optionList={episodeDropData}
                    value={detailData?.depend_episode}
                    onChange={handleSelectChange}
                    style={{ width: '100%' }}
                  />
                  <DefaultRadio
                    title='엔딩 종류'
                    name='ending_type'
                    optionList={EndingType}
                    defaultValue={detailData?.ending_type}
                    onChange={handleInputChange}
                    style={{ marginLeft: '1.5rem' }}
                  />
                </InputFlexBox>
              )}
            </>
          </InputWrappingBox>
          <>
            {episode_type === 'ending' && (
              <>
                <InputWrappingBox style={{ marginBottom: '1.5rem' }}>
                  <DefaultSelect
                    title='캐릭터'
                    name='speaker'
                    optionList={characterDropList}
                    value={detailData?.speaker}
                    onChange={handleSelectChange}
                  />
                </InputWrappingBox>
                <InputWrappingBox>
                  <ImageSelect
                    labelTitle='팝업 썸네일'
                    name='popup_image_id'
                    placement='topLeft'
                    optionList={popThumbnailDropList}
                    value={detailData?.popup_image_id}
                    onChange={handleSelectChange}
                  />
                </InputWrappingBox>
              </>
            )}
          </>
        </div>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default DLCEpisodeUpdatePage;
